<div class="L-12 M-12 S-12 columns" [ngClass]="{'no-gap': noGap, 'm-0': noMargin, 'h-100': height100, 'new-table': newStyle, 'detail-table': detailStyle, 'TableConteiner': !newStyle && !detailStyle }" [ngStyle]="{'max-height': maxHeight ? maxHeight : ''}">
  <table class="scene" [ngClass]="{'full':full, 'm-0': noMargin }">
    <thead>
      <tr>
        @if (addCheck) {
          <th class="addCheck">
            <input type="checkbox" name="checked_all" [(ngModel)]="checked_all" (ngModelChange)="check_list()">
          </th>
        }
        @for (head of headersShow; track head; let i = $index) {
          <th [ngClass]="{'sticky-left': head.sticky}" [ngStyle]="{left: head.sticky? addCheck ? head.sticky_value + (i*3) + 37 + 'px' : head.sticky_value + (i*3) + 'px':''}">
            <div (click)="ordertable(head)">
              <ng-container *ngTemplateOutlet="tableHeaders; context{'head': head}"></ng-container>
            </div>
          </th>
        }
        @if (showMobileMenu && (_gS.isMobile$ | async)) {
          <th class="option-table sticky-right right-option">&nbsp;</th>
        }
      </tr>
    </thead>
    @if (!hideContent) {
      <tbody>
        @for (item of list | slice:sliceStart:(sliceStart + sliceSize); track item; let i = $index) {
          @if (item) {
            <tr (dblclick)="dblclick($event, item)" (contextmenu)="_gS.rigthClick($event, 3); selectRow(item)" (click)="click($event, item)">
              @if (addCheck) {
                <td class="addCheck">
                  <div>
                    <input type="checkbox" name="{{'checked_' + i}}" [(ngModel)]="item.checked" (ngModelChange)="changeBulk(item)">
                  </div>
                </td>
              }
              @for (head of headersShow; track head; let i = $index) {
                <td [ngStyle]="{left: head.sticky? addCheck ? head.sticky_value + (i*3) + 37 + 'px' : head.sticky_value + (i*3) + 'px':''}" [class]="checkClass(item, head)">
                  <div [class]="head.class" [ngStyle]="{'width.px': head.width ? head.width  : 'auto', 'margin': '0 auto' }" [ngClass]="{'hasElement': (head.type == 'list' || head.type == 'list_back_translate'), 'flex align-center': head.hasMiniImage}">
                    @if ((head.type == 'list' || head.type == 'list_back_translate') && getValue(item, head, true)) {
                      <span class="number">{{ item | getValue: head : true}}</span>
                    }
                    @if (head.hasMiniImage) {
                      <div class="box-img">
                        @if (item[head.value_image]) {
                          <img [src]="item[head.value_image]" imageLoader (load)="_gS.loadImage()">
                        }
                        @if (!item[head.value_image]) {
                          <div>
                            <span>{{item[head.value_initials].toLowerCase() | abbreviation}}</span>
                          </div>
                        }
                      </div>
                    }
                    @if (head.type != 'link' && head.type != 'user_list' && !newStyle && head.type != 'progress_bar' && head.type != 'progress-status' && head.type != 'title_subtitle' && head.type != 'options') {
                      <span [class]="checkColorClass(item, head)">
                        {{ item | getValue: head | isNull:'string' }}
                      </span>
                    }
                    @if (head.type != 'link' && head.type != 'user_list' && newStyle && head.type != 'progress_bar' && head.type != 'progress-status' && head.type != 'title_subtitle' && head.type != 'options') {
                      <span>
                        {{ item | getValue: head | slice: 0:22 }}
                        @if (getValue(item, head)?.length > 22) {
                          <span>...</span>
                        }
                      </span>
                    }
                    @if (head.type == 'title_subtitle') {
                      <span [ngClass]="{ 'title': newStyle }">
                        {{ getValue(item, head)[0] | isNull:'string' }}
                      </span>
                      <span [ngClass]="{ 'subtitle': newStyle }">{{ getValue(item, head)[1] | uppercase | isNull: 'string' }}</span>
                    }
                    @if (head.type == 'link' && head.value) {
                      @if (item[head.href]) {
                        <a target="_blank" style="color:rgb(10, 169, 238);" [href]="item[head.href]" (contextmenu)="$event.stopPropagation()">{{ item | getValue: head }}</a>
                      }
                      @if (!item[head.href]) {
                        {{ item | getValue: head }}
                      }
                    }
                    @if (head.type == 'options' && head.value) {
                      <div [ngClass]="{'semaphore-grid': head.semaphore}">
                        @if (head.semaphore) {
                          <div class="circle" [class]="item[head.semaphoreValue]"></div>
                        }
                        @if (item[head.semaphoreValue] != 'orange') {
                          @if (getValue(item, head) == 'DELIVER') {
                            <div class="alignRight optionbtn">
                              <button type="button" (click)="sendOptionId($event, item, head)">
                                {{ 'DELIVER' | translate | uppercase }}
                              </button>
                            </div>
                          }
                          @if (changeColorOption) {
                            <div class="alignRight">
                              @for (option of head.multipleOptions; track option) {
                                <button class="btn-icon" [disabled]="option.disabled ? 'disabled' : null" [title]="option.name" (click)="sendOptionId($event, item, head, option.id)">
                                  <span [ngStyle]="{ 'color': option.color }" class="material-icons">{{option.icon}}</span>
                                </button>
                              }
                            </div>
                          }
                        }
                      </div>
                    }
                    @if (head.type == 'progress_bar') {
                      <app-progress-bar [progress]="item | getValue: head"></app-progress-bar>
                    }
                    @if (head.type == 'progress-status') {
                      <app-progres-status [colors]="item[head.value]"></app-progres-status>
                    }
                    @if (head.type == 'comments') {
                      <div (click)="onClickComment($event, item)">
                        <span class="material-icons filter-btn-comment" style="color:rgb(10, 169, 238);">{{item[head.value_initials].length  > 0 ?  "forum" : "add_comment"}} </span>
                        <a  class= "filter-btn-comment-total" >
                          {{item[head.value_initials].length || ""}}
                        </a>
                      </div>
                    }
                    @if (head.type == 'user_list') {
                      @for (user of item[head.list]| slice: 0:2; track user) {
                        <div class="box-img box-imgg-asset" >
                          @if (user[head.value_image]) {
                            <img [src]="user[head.value_image]" imageLoader (load)="_gS.loadImage()">
                          }
                          @if (!user[head.value_image]) {
                            <div (mouseleave)="_gS.hidemenu(); onCleanMenu($event)" (mouseenter)="onClickUser($event, item, user)">
                              <span>{{user[head.value_initials].toLowerCase() | slice: 0:2}}</span>
                            </div>
                          }
                        </div>
                      }
                      @if (item[head.list].length > 2) {
                        <div class="box-img box-imgg-asset" >
                          <div (mouseleave)="_gS.hidemenu(); onCleanMenu($event)" (mouseenter)="onClickUser($event, item)">
                            <span>+{{item[head.list].length - 2}}</span>
                          </div>
                        </div>
                      }
                    }
                  </div>
                </td>
              }
              @if (showMobileMenu && (_gS.isMobile$ | async)) {
                <td class="option-table sticky-right right-option" (click)="_gS.rigthClick($event, 3); $event.stopPropagation(); selectRow(item)">
                  <div>
                    <span class="material-icons more-menu circle filled">more_horiz</span>
                  </div>
                </td>
              }
            </tr>
          }
        }
      </tbody>
    }
  </table>
  @if (!list.length) {
    <div class="no-record">
      {{"No matching record found" | translate}}
      @if (clearFiltersBtn) {
        <a
          class="clear-filters button"
          (click)="clearFilters()">
          {{'Clear filters' | translate}}
        </a>
      }
    </div>
  }
</div>
@if (pagination) {
  <div class="tablePagination">
    @if (printSliceStart > 0) {
      <i class="first" (click)="changePagPosition('first')"></i>
    }
    @if (printSliceStart > 0) {
      <i class="previous" (click)="changePagPosition('previous')"></i>
    }
    <div class="values">
      {{printSliceStart + 1}} {{'To' | translate }} {{(printSliceStart + printSliceSize) < list.length ? (printSliceStart + printSliceSize) : list.length}} {{'Of' | translate}} {{list.length}}
    </div>
    @if (printSliceStart + printSliceSize < list.length) {
      <i class="next" (click)="changePagPosition('next')"></i>
    }
    @if (printSliceStart + printSliceSize < list.length) {
      <i class="last" (click)="changePagPosition('last')"></i>
    }
  </div>
}

<!-- Filter context -->
@if (showFilterMenu) {
  <div class="container-context-menu">
    @if (_gS.showContext) {
      <div class="contextmenuConteiner" (click)="_gS.hidemenu($event); showFilterMenu = false"></div>
    }
    <div class="filter-contextmenu" [style.left]="_gS.contextmenux" [style.top]="_gS.contextmenuy" style="z-index: 1001;">
      <ng-container *ngTemplateOutlet="filterTemplate"></ng-container>
    </div>
  </div>
}

<!-- Header template -->
<ng-template #tableHeaders let-head="head">
  <div [ngClass]="{ 'bold-head': head.class == 'bold' }" [ngStyle]="{'width.px': head.width ? head.width  :'auto', 'margin': '0 auto' }">
    @if (head.canFilter) {
      @if (head.isFilterActive) {
        <span class="material-icons filter-btn active" (click)="filterTable($event, head)">filter_alt</span>
      }
      @if (!head.isFilterActive) {
        <span class="material-icons filter-btn" (click)="filterTable($event, head)">filter_list</span>
      }
    }
    @if (head.icon) {
      <span (click)="hideContent = !hideContent" class="material-icons">
        keyboard_arrow_down
      </span>
    }
    {{ head.name | translate }}
    @if (canOrder && head.type != 'title_subtitle') {
      @if ( head.type == 'back_translate' ?  head.value + '_' + _gS.getLenguage()  == orderBy[0] : (head.value == orderBy[0] || (head.orderData == orderBy[0] && head.orderData))) {
        <span class="Arrow down"></span>
      }
      @if ( head.type == 'back_translate' ?  head.value + '_' + _gS.getLenguage()  + ' DESC'  == orderBy[0] : (head.value + ' DESC' == orderBy[0] || (head.orderData + ' DESC' == orderBy[0] && head.orderData))) {
        <span class="Arrow up"></span>
      }
    }
    @if (canOrder && head.type == 'title_subtitle') {
      @if ( head.type == 'title_subtitle' ?  head.value + '_' + _gS.getLenguage()  == orderBy[0] : (head.value == orderBy[0] || (head.orderData == orderBy[0] && head.orderData))) {
        <span class="Arrow down"></span>
      }
      @if ( head.type == 'title_subtitle' ?  head.value + '_' + _gS.getLenguage()  + ' DESC'  == orderBy[0] : (head.value + ' DESC' == orderBy[0] || (head.orderData + ' DESC' == orderBy[0] && head.orderData))) {
        <span class="Arrow up"></span>
      }
    }
    @if (head.typeHead == 'progress-bar' && progressHead != null && progressHead != undefined) {
      <app-progress-bar [detailsStyle]="true" [progress]="progressHead"></app-progress-bar>
    }
  </div>
</ng-template>